import { Component, inject } from '@angular/core';
import { BaseDialogComponent } from '../../../../kit/base-dialog/base-dialog.component';
import { FolderGlobalStore } from '../../../../../store/medicalService/folder.global-store';
import { routeParams } from '../../../../../modules/shared/shared.global-service';
import { WorkGroupActivityComponent } from '../work-group-activity.component';

@Component({
    selector: 'app-work-group-activity-dialog',
    templateUrl: './work-group-activity-dialog.component.html',
    styleUrl: './work-group-activity-dialog.component.scss',
    imports: [
        WorkGroupActivityComponent,
    ],
})
export class WorkGroupActivityDialogComponent extends BaseDialogComponent {

    protected readonly folderStore = inject(FolderGlobalStore);

    constructor() {
        super();
        this.folderStore.setFolderId(routeParams.folderId());
        this.folderStore.setDialogComponent(this);
    }

}
